import React from "react";
import { useDataLoader } from "react-remote-data-hooks/dist/useDataLoader";
import api from "../../api";
import API_DOMAIN from "../../api/apiDomain";
import userDefaultImage from "../../assets/images/user-noimage.png";
import { MediaFile } from "../../core";

const UserAvatarIcon: React.FunctionComponent<{
  id?: string;
  imageUrl?: string;
  image?: MediaFile;
}> = (props) => {
  const imgRef = React.useRef<HTMLImageElement>(null);

  const addDefaultSrc = () => {
    if (imgRef && imgRef.current && imgRef.current.src) {
      imgRef.current.src = userDefaultImage;
    }
  };

  const { data: signedUrl } = useDataLoader<string>(
    async (mediaFile?: MediaFile) =>
      mediaFile ? api.upload.getSignedMediaFileUrl(mediaFile) : undefined,
    [props.image]
  );

  return (
    <div className="avatar-progress position-relative cursor-pointer">
      <svg>
        <circle r="19" cx="50%" cy="50%" className="default"></circle>
        <circle
          r="19"
          cx="50%"
          cy="50%"
          className="progress"
          strokeDasharray="117"
          strokeDashoffset="45"
        ></circle>
      </svg>
      {props.id ? (
        <img
          src={signedUrl || `${API_DOMAIN}/api/user/${props.id}/profile-photo`}
          className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
          alt="user"
          title="user"
          ref={imgRef}
          onError={addDefaultSrc}
        />
      ) : (
        <img
          src={userDefaultImage}
          className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
          alt="user"
          title="user"
          ref={imgRef}
          onError={addDefaultSrc}
        />
      )}
    </div>
  );
};

export default UserAvatarIcon;
